// extracted by mini-css-extract-plugin
export default {"signOnBTN":"button_signOnBTN__s2Eis"};